import Modal from 'components/common/modal';
import React, { useCallback, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { openContactUs } from 'utils/billing-plan-cards.utils';
import { EventNames } from 'utils/analytics.utils';
import { observer } from 'mobx-react';
import useStores from 'hooks/use-stores.hooks';
import { useLocation } from 'react-router-dom';
import styled from 'types/theme.types';

const PayGate: React.FunctionComponent = () => {
  const { payGateStore } = useStores();
  const location = useLocation();

  const route = location.pathname + location.search;

  useEffect(() => {
    payGateStore.checkCachedRoute(route);
  }, [payGateStore, route]);

  const onClose = useCallback(() => {
    payGateStore.clearActivePayGateError();
  }, [payGateStore]);

  const onContactUsClick = useCallback(() => {
    onClose();
    openContactUs(EventNames.CONTACT_US_PAY_GATE_CLICK);
  }, [onClose]);

  return (
    <ModalWithLineBreaks
      open={!!payGateStore.activePayGateErrorText}
      width={600}
      onOk={onContactUsClick}
      onCancel={onClose}
      titleId="pay-gate.title"
      destroyOnClose
      maskClosable
      maskStyle={{ backdropFilter: 'blur(4px)' }}
      cancelButtonProps={{ style: { display: 'none' } }}
      okText={<FormattedMessage id="billing.contact-us" />}
      centered>
      {payGateStore.activePayGateErrorText}
    </ModalWithLineBreaks>
  );
};

const ModalWithLineBreaks = styled(Modal)`
  white-space: pre-line;
`;

export default observer(PayGate);
